import { Component } from '@angular/core';

@Component({
  selector: 'app-egg-spinner-overlay',
  templateUrl: './egg-spinner-overlay.component.html',
  styleUrls: ['./egg-spinner-overlay.component.scss'],
  standalone: true,
})
export class EggSpinnerOverlayComponent {}
